import { render } from "./KalenderMaaned.vue?vue&type=template&id=58c83b14"
import script from "./KalenderMaaned.vue?vue&type=script&lang=js"
export * from "./KalenderMaaned.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__